<app-navbar title="Lokalizacje">
	<a routerLink="./add" class="btn btn-primary"> <i class="fas fa-plus"></i> Dodaj </a>
</app-navbar>

<app-locations-list-filters
	userFilters="location"
	[id]="parameters.id"
	[offset]="parameters.offset"
	[search]="parameters.search"
	(selected)="filtersSelected($event)"
	[forceFilters]="{ limit: 9999 }"
></app-locations-list-filters>

<app-dynamic-table
	module="location"
	[elements]="data"
	[tableRows]="tableRows"
	(filtersClicked)="filtersOpen()"
></app-dynamic-table>
